import autocomplete from "@/presets/lara/autocomplete";

export const autoCompletePt = {
  ...autocomplete,
  // One border wraps the whole control: the root carries it (color and ring
  // come from the component, which knows the invalid state) and the input and
  // caret button inside are borderless, so the two elements read as a single
  // field instead of two boxes butted together.
  root: ({ props }) => ({
    class: [
      ...autocomplete.root({ props }).class,
      "w-full h-10 rounded-md border bg-white",
      "focus-within:ring",
      "transition-colors duration-200",
    ],
  }),
  input: () => ({
    class: [
      "w-full px-3 text-sm rounded-md",
      "appearance-none bg-transparent border-0 outline-none focus:ring-0",
      "placeholder:text-placeholder",
    ],
  }),
  dropdownbutton: {
    root: {
      class: [
        "relative items-center inline-flex text-center align-bottom",
        "rounded-r-md px-3 leading-none",
        "text-gray-600 hover:bg-gray-50",
        "focus:outline-none",
      ],
    },
  },
  item: ({ context }) => ({
    class: [...autocomplete.item({ context }).class, "!px-2.5 !py-2"],
  }),
};
